import * as actionType from './actionTypes';

const initialState = {
  requestCount: 0
};

const reducer = (state = initialState, action) => {
  let count = state.requestCount;
  switch (action.type) {
    case actionType.SET_VISIBILITY:
      if (action.payload === true) {
        count++;
      } else {
        count--;
      }
      if (count < 0) {
        count = 0;
      }
      return {
        ...state,
        requestCount: count
      };
    default:
      return state;
  }
};

export default reducer;
